import routes from './routes';
import { SetRoutes } from 'components';

const ExperienceYearsPages = () => {
  return (
    <>
      <SetRoutes routes={routes} />
    </>
  );
};

export default ExperienceYearsPages;
